import { useEffect } from "react";

/**
 * Disable hover effects tokom scroll-a za bolje performanse
 * Hover efekti su NAJSKUPLJI tokom scroll-a jer browser mora
 * konstantno rekalkulisati hover state
 */

export const useDisableHoverOnScroll = () => {
  useEffect(() => {
    let scrollTimer = null;
    let isScrolling = false;

    const handleScroll = () => {
      // Ako već scroll-uje, samo resetuj timer
      if (isScrolling) {
        clearTimeout(scrollTimer);
      } else {
        // Prvi scroll event - disable hover
        isScrolling = true;
        document.body.classList.add("disable-hover");
      }

      // Re-enable hover 150ms nakon što scroll stane
      scrollTimer = setTimeout(() => {
        isScrolling = false;
        document.body.classList.remove("disable-hover");
      }, 150);
    };

    // Passive listener za bolje performanse
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollTimer) clearTimeout(scrollTimer);
      document.body.classList.remove("disable-hover");
    };
  }, []);
};

export default useDisableHoverOnScroll;
